import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authService from "../../services/auth.service";
import courses from "../AdmissionFom/courses";

const PrintComponent = () => {

 
  
 

  const contentRef = useRef(null);

    const [paymentStatus,setpaymentStatus] = useState("")
    
 


const dateTime = String( paymentStatus.addedon);
const [date, time] = dateTime.split(" ");
// console.log(date); // "2025-08-30"
console.log(time); // "18:42:05"

  const handlePrint = () => {
    setTimeout(() => {
      const printContent = contentRef.current;

      const printWindow = window.open();

      printWindow.document.write(`
        <html>
          <head>
            <title>Student Fee Chalan</title>
            <style>


              li{
              margin:0;
               padding:0;
              }

              p{
              margin:0;
               padding:0
              }

              h1,h2,h3,h4,h5,h6{
               margin:0;padding:0
              }

              .Print-chalan-page-container-modal {
                border: 1px solid lightgray;
                height:900px;
              }

              .Print-chalan-page-header {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                text-align: center;
                border-bottom: 1px solid lightgray;
                margin-bottom: 10px;
                padding: 10px;
              }

              .Print-chalan-page-header > img {
                width: 16%;
              }

              .Print-chalan-page-title {
                margin-bottom: 8px;
                color: #2c3e50;
                font-size: 23px;
                font-weight: 600;
              }

              .Print-chalan-page-content {
                  padding: 10px 10px;
              }
              .print-chalan-page-box {
                display: grid;
                grid-template-columns: 1fr 150px;
              }

              .print-chalan-page-student-details > ul {
                display: flex;
                gap: 10px;
                flex-direction: column;
              }

              .print-chalan-page-student-details > ul > li > div {
                display: flex;
                flex-direction: row;
                gap: 30px;
              }

              .print-chalan-page-student-details > ul > li > div > p:first-child {
                font-weight: 600;
              }

              .Print-chalan-page-section-title {
                margin-top: 0;
                color: #2c3e50;
                border-bottom: 1px solid lightgray;
                padding: 20px 0px; 
                text-align: center;
                margin-bottom: 0;
              }

              .Print-chalan-page-details{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex-wrap: wrap;
                gap: 10px;
                padding: 20px;
              }

              .Print-chalan-page-detail-item{
                width: calc(90%/2);
                display: flex;
                flex-direction: row;
                gap: 10px;
              }

              .Print-chalan-page-detail-value{
                margin-bottom: 0px;
                text-align: end;
              }

              .Print-chalan-detail-label{
                font-weight: 600;
              }

              .Print-chalan-printable-content {
                display: block;
                padding: 20px;
                max-width: 900px;
                margin: auto;
              }

              .print-chalan-student-profile-image {
                width: 60%;
              }

              .print-chalan-student-signature-image {
                width: 60%; 
              }

              .Signature-box{
                border: 1px solid black;
                padding: 10px 100px;
              }

              .Signature-box {
    border: 1px solid black;
    padding: 30px 100px;
}

              .Print-chalan-subtitle{
  margin-bottom: 10px;
}


              @media screen {

                .Print-chalan-printable-content {
                  display: block;
                  padding: 20px;
                  max-width: 900px;
                  margin: auto;
                }

                .Signature-box {
    border: 1px solid black;
    padding: 30px 100px;
}
          
                .Print-chalan-page-container-modal {
                  border: 1px solid lightgray;
                   height:900px;
                }

                .Print-chalan-page-header {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  text-align: center;
                  border-bottom: 1px solid lightgray;
                  margin-bottom: 10px;
                  padding: 10px;
                }

                .Print-chalan-page-header > img {
                  width: 16%;
                }

                .Print-chalan-page-title {
                  margin-bottom: 8px;
                  color: #2c3e50;
                  font-size: 23px;
                  font-weight: 600;
                }

                .Print-chalan-page-content {
                    padding: 10px 10px;
                }
                .print-chalan-page-box {
                  display: grid;
                  grid-template-columns: 1fr 150px;
                }

                .print-chalan-page-student-details > ul {
                  display: flex;
                  gap: 10px;
                  flex-direction: column;
                }

                .print-chalan-page-student-details > ul > li > div {
                  display: flex;
                  flex-direction: row;
                  gap: 30px;
                }

                .print-chalan-page-student-details > ul > li > div > p:first-child {
                  font-weight: 600;
                }

                .Print-chalan-page-section-title {
                  margin-top: 0;
                  color: #2c3e50;
                  border-bottom: 1px solid lightgray;
                  padding: 20px 0px;
                  text-align: center;
                  margin-bottom: 0;
                }

                .Print-chalan-page-details{
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  flex-wrap: wrap;
                  gap: 10px;
                  padding: 20px;
                }

                .Print-chalan-page-detail-item{
                  width: calc(98%/2);
                  display: flex;
                  flex-direction: row;
                  gap: 10px;
                }

                .Print-chalan-page-detail-value{
                  margin-bottom: 0px;
                  text-align: end;
                }
                
                .Print-chalan-detail-label{
                  font-weight: 600;
                }

                .print-chalan-student-profile-image {
                  width: 60%;
                }

                .print-chalan-student-signature-image {
                  width: 60%; 
                }

                .Signature-box{
                  border: 1px solid black;
                  padding: 10px 100px;
                }

                .Print-chalan-subtitle{
  margin-bottom: 10px;
}

              }



              @media print {
                
                body {
                  padding: 15px;
                }

                .Signature-box {
    border: 1px solid black;
    padding: 30px 100px;
}

                .Print-chalan-detail-label{
                font-weight: 600;
                }

                .Print-chalan-section {
                  page-break-inside: avoid;
                }

                .Print-chalan-image-container {
                  page-break-inside: avoid;
                }

                
                .Print-chalan-printable-content {
                  display: block;
                  padding: 20px;
                  max-width: 900px;
                  margin: auto;
                }

                li{
                  margin:0;
                  padding:0;
                  list-style-type:none;
                }

                p{
                  margin:0;
                  padding:0
                }

                h1,h2,h3,h4,h5,h6{
                  margin:0;padding:0
                }


                .Print-chalan-page-container-modal {
                  border: 1px solid lightgray;
                   height:900px;
                }

                .Print-chalan-page-header {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  text-align: center;
                  border-bottom: 1px solid lightgray;
                  margin-bottom: 10px;
                  padding: 10px;
                }

                .Print-chalan-page-header > img {
                  width: 16%;
                }

                .Print-chalan-page-title {
                  margin-bottom: 8px;
                  color: #2c3e50;
                  font-size: 23px;
                  font-weight: 600;
                }

                .Print-chalan-page-content {
                    padding: 10px 10px;
                }

                .print-chalan-page-box {
                  display: grid;
                  grid-template-columns: 1fr 150px;
                }

                .print-chalan-page-student-details > ul {
                  display: flex;
                  gap: 10px;
                  flex-direction: column;
                }

                .print-chalan-page-student-details > ul > li > div {
                  display: flex;
                  flex-direction: row;
                  gap: 30px;
                }

                .print-chalan-page-student-details > ul > li > div > p:first-child {
                  font-weight: 600;
                  font-size:15px;
                }


                .Print-chalan-page-section-title {
                  margin-top: 0;
                  color: #2c3e50;
                  border-bottom: 1px solid lightgray;
                  padding: 20px 0px;
                  text-align: center;
                  margin-bottom: 0;
                }

                .Print-chalan-page-details{
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  flex-wrap: wrap;
                  gap: 10px;
                  padding: 20px;
                }

                .Print-chalan-page-detail-item{
                  width: calc(98%/2);
                  display: flex;
                  flex-direction: row;
                  gap: 10px;
                }


                .Print-chalan-page-detail-value{
                  margin-bottom: 0px;
                  text-align: end;
                }

                .print-chalan-student-profile-image {
                  width: 60%; 
                }

                .print-chalan-student-signature-image {
                  width: 60%;
                }

                .Signature-box{
                  border: 1px solid black;
                  padding: 30px 100px;
                }

                .Print-chalan-subtitle{
  margin-bottom: 10px;
}

                .Chalan-page-auth{
                  display: flex;
                    justify-content: end;
                    position: relative;
                    bottom: 0px;
                }

                .Chalan-page-auth > ul {
                  display: flex;
                  flex-direction: column;
                  gap: 10px;
                }

                .Chalan-page-auth > ul >li{
                  display: flex;
                  flex-direction: row; 
                  gap: 10px;
                }

                .Chalan-page-auth > ul > li > input{
                  margin: 0;
                } 

                .Chalan-page-auth > ul > span {
                  border: 1px solid black;
                  padding: 10px 40px;
                }
              }
             </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
        </html>
      `);

      printWindow.document.close();

      printWindow.focus();

      // document.querySelector(".print-button-chalan-page").style.display =
      //   "none";

      printWindow.onload = function () {
        printWindow.print();

        printWindow.close();
      };
    }, 100);
  };


    const dispatch = useDispatch();
        
        useEffect(() => {
           authService.getUser(dispatch);
        }, []);
    
      const studentInformation = useSelector((state) => state.auth.studentData);

  useEffect(() => {
    if (
      !studentInformation ||
      !Array.isArray(studentInformation.transactions) ||
      studentInformation.transactions.length === 0
    ) {
      setpaymentStatus("Pending");
    } else {
      const filtered = studentInformation.transactions.filter(
        (t)=>t.amount == 50 && String(t.status).toLowerCase() === "success"
      );
      setpaymentStatus(
        filtered.length > 0 ? filtered[filtered.length - 1] : "Pending"
      );
    }
  }, [studentInformation]);

  if (!studentInformation || Object.keys(studentInformation).length === 0) {
    return <div>Loading...</div>;
  }


  const pgug = courses.filter((item)=> item.code === studentInformation.course_name)
  console.log(pgug)


 



  return (
    <div
      style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}
      className="Print-chalan-main-container no-print"
    >
          <button className="print-button-chalan-page" onClick={handlePrint}>
              Print
            </button>
      <div ref={contentRef} className="Print-chalan-printable-content">
        <div className="Print-chalan-page-container-modal">
          <div className="Print-chalan-page-header">
            <img src="https://campus.acetians.in/custom/images/1722342842lalitpurlogo.png" />
            <div>
              <h2 onClick={()=>console.log(studentInformation)} className="Print-chalan-page-title">
                रघुवीर सिंह राजकीय महाविद्यालय, ललितपुर,(उo.प्रo)
              </h2>

              {/* <button onClick={()=>console.log(paymentStatus)}>pay</button>
              <button onClick={()=>console.log(studentInformation)}>check</button> */}

              <p className="Print-chalan-subtitle">नैक ग्रेड – बी</p>
              <h2 className="Print-chalan-page-title">पंजीकरण फॉर्म</h2>
              <p className="Print-chalan-subtitle"> Academic Year 2025-26</p>
            </div>
            <img src={"https://vbsgdc.org.in/uploads/2023/05/Uttar_Pradesh.png"} />
          </div>

          <div className="Print-chalan-page-content">
            <div className="print-chalan-page-box">
              <div className="print-chalan-page-student-details">
                <ul>
                  <li>
                    <div>
                      <p>नाम:</p>
                      <p>{studentInformation.name || ""}</p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <p>श्रेणी:</p>
                      <p>{studentInformation.category || ""}</p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <p>शैक्षिक स्तर:</p>
                      <p>{pgug[0].type || ""}</p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <p>प्रवेश का प्रकार:</p>
                      <p>{studentInformation.course_year === "1" ? "New" :  studentInformation.course_year === "2" || studentInformation.course_year === "3" && "Renewal"}</p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <p>पाठ्यक्रम का नाम:</p>
                      <p>{pgug[0].name2 || ""}</p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <p>पाठ्यक्रम का वर्ष:</p>
                     {studentInformation.course_year === "1" ? "First Year" :  studentInformation.course_year === "2" ? "Second Year" :  studentInformation.course_year === "2" && "Thirt Year"}
                    </div>
                  </li>

                  {/* {student.courseType === "Renewal" ? (
                    <li>
                      <div>
                        <p>रोल नंबर:</p>
                        <p>{student.rollNumber || ""}</p>
                      </div>
                    </li>
                  ) : (
                    ""
                  )} */}

                  <li>
                    <div>
                      <p>छात्र हस्ताक्षर:</p>

                      <span className="Signature-box"></span>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="print-chalan-image-box">
                <img
                  className="print-chalan-student-profile-image"
                  src={
                    studentInformation.profile_photo ||
                    "https://i-be-c.org/wp-content/uploads/2016/03/silhouette_speaker.jpg"
                  }
                  alt="Student Profile"
                />
              </div>
            </div>

            <div className="Print-chalan-page-section">
              <h3 className="Print-chalan-page-section-title">
                Registration Fee Details
              </h3>

              <div className="Print-chalan-page-details">
                <div className="Print-chalan-page-detail-item">
                  <p className="Print-chalan-detail-label">दिनांक:</p>
                  <p className="Print-chalan-detail-value">
                    {date || "0"}
                  </p>
                </div>

                <div className="Print-chalan-page-detail-item">
                  <p className="Print-chalan-detail-label">
                    ऑनलाइन भुगतान संख्या:
                  </p>
                  <p className="Print-chalan-detail-value">
                    {paymentStatus.txnid  || "0"}
                  </p>
                </div>

                <div className="Print-chalan-page-detail-item">
                  <p className="Print-chalan-detail-label">समय:</p>
                  <p className="Print-chalan-detail-value">
                    {time || "0"}
                  </p>
                </div>

                <div className="Print-chalan-page-detail-item">
                  <p className="Print-chalan-detail-label">
                    जमा किया गया शुल्क:
                  </p>
                  <p className="Print-chalan-detail-value">
                    {`₹${paymentStatus.amount || "0"}`}
                  </p>
                </div>

                {/* <div className="Print-chalan-page-detail-item">
                  <p className="Print-chalan-detail-label">
                    जमा किया गया शुल्क शब्दों में:
                  </p>
                  <p className="Print-chalan-detail-value">
                       {paymentStatus.amount || "0"}
                  </p>
                </div> */}
              </div>
            </div>

            <div>
              {/* {student.courseType === "Renewal" && ( */}
              <div className="Chalan-page-auth">
                <ul>
                  <li>
                    <input type="checkbox" />
                    <lable>Approved </lable>
                  </li>
                  <li>
                    <input type="checkbox" />
                    <lable>Declined</lable>
                  </li>
                  <span>Signature of Admission In-Charge</span>
                </ul>
              </div>

              {/* )} */}
            </div>

        
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintComponent;
